import React, { FC, useState } from 'react';
import { darken, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { Network } from 'api';
import { connectionPopup } from 'helpers';
import { useSocialConnections } from 'hooks';
import { PaddedPaper, SocialIcon } from 'components';
import cookieStorage from 'cookie-storage';
import useNetworkCapabilities from 'hooks/useNetworkCapabilities';

const CONNECTION_CTA_VALUE = 'dismissed';

const Welcome: FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isDismissed = cookieStorage.connectionCta === CONNECTION_CTA_VALUE;
  const { connections } = useSocialConnections();
  const [dismissed, setDismissed] = useState(isDismissed);
  const { hasTwitter } = useNetworkCapabilities();

  if (dismissed || connections.length) {
    return null;
  }

  function handleDismiss() {
    cookieStorage.connectionCta = CONNECTION_CTA_VALUE;
    setDismissed(true);
  }

  return (
    <PaddedPaper sx={{ marginBottom: 4 }}>
      <Typography align="center" variant="subtitle2">
        {t('onboarding:timelineConnections')}
      </Typography>
      <Grid
        container
        alignItems="center"
        justifyContent="space-evenly"
        sx={{
          paddingTop: 3,
          paddingBottom: 3,
        }}
      >
        {hasTwitter && (
          <Grid>
            <Button
              variant="contained"
              onClick={() => connectionPopup(Network.Twitter)}
              startIcon={<SocialIcon state="inverted" provider="twitter" size={20} />}
              sx={{
                borderRadius: 4,
                color: 'common.white',
                backgroundColor: theme.custom.networks.x,
                '&:hover': {
                  backgroundColor: darken(theme.custom.networks.x, 0.1),
                },
              }}
            >
              {t('user:connectTwitter')}
            </Button>
          </Grid>
        )}
        <Grid>
          <Button
            variant="contained"
            onClick={() => connectionPopup(Network.Linkedin)}
            startIcon={<SocialIcon state="inverted" provider="linkedin" size={20} />}
            sx={{
              borderRadius: 4,
              color: 'common.white',
              backgroundColor: theme.custom.networks.linkedin,
              '&:hover': {
                backgroundColor: darken(theme.custom.networks.linkedin, 0.1),
              },
            }}
          >
            {t('user:connectLinkedIn')}
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ margin: '0 auto' }}>
        <Button fullWidth onClick={handleDismiss}>
          {t('onboarding:timelineDismiss')}
        </Button>
      </Box>
    </PaddedPaper>
  );
};

export default Welcome;
